import { configureStore } from "@reduxjs/toolkit";
import otpAuthSlice from "@/redux/slices/otpAuthSlice";
import AlertMessageSlice from "@/redux/slices/AlertMessageSlice";
import OrderSlice from "@/redux/slices/order-processing-slices/OrderSlice";
import MagicSlice from "@/redux/slices/MagicSlice";
import CartSlice from "@/redux/slices/product-processing-slices/CartSlice";
import ProductProcessingSlice from "@/redux/slices/product-processing-slices/ProductProcessingSlice";
import AddressSlice from "@/redux/slices/user-processing-slices/AddressSlice";
import CustomDomainSlice from "@/redux/slices/customDomainSlice";
import ARShapesSlice from "@/redux/slices/ARShapesSlice";

export const store = configureStore({
  reducer: {
    auth: otpAuthSlice,
    notification: AlertMessageSlice,
    order: OrderSlice,
    magic: MagicSlice,
    cart: CartSlice,
    product: ProductProcessingSlice,
    address: AddressSlice,
    custom: CustomDomainSlice,
    arShapes: ARShapesSlice,
  },
  middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(),
});
